import { render, staticRenderFns } from "./HomePageIT.vue?vue&type=template&id=0b68be7c&scoped=true"
import script from "./HomePageIT.vue?vue&type=script&lang=js"
export * from "./HomePageIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68be7c",
  null
  
)

export default component.exports